
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refer/new/[referralCode]",
      function () {
        return require("private-next-pages/refer/new/[referralCode]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refer/new/[referralCode]"])
      });
    }
  